import api from "@/api/motivationAdmin"

export default {
  async getPromotions({commit}: any) {
    const result = await api.getPromotions()
    // API отдаёт {results}, хотя в доке массив — поддерживаем оба
    const list = result?.results || result || []
    commit("setPromotions", list)
    return list
  },
  async updatePromotion({commit}: any, {pk, data}: any) {
    const result = await api.updatePromotion(pk, data)
    commit("setPromotion", result)
    return result
  },
  async getLetters({commit}: any, {pk, params}: any) {
    const result = await api.getLetters(pk, params)
    commit("setLetters", {results: result?.results, count: result?.count})
    return result
  },
  async getBonuses({commit}: any, {pk, params}: any) {
    const result = await api.getBonuses(pk, params)
    commit("setBonuses", {results: result?.results, count: result?.count})
    return result
  },
  getClientFilterOptions(_: any, {pk, filter}: any) {
    return api.getClientFilterOptions(pk, filter)
  },
}
